import { LAST_UPDATED, LAST_UPDATED_FR } from "../lib/lastUpdated";

export default function LastUpdated({ className = "" }) {
    return (
        <p className={`inline-flex items-center gap-2 text-xs text-[var(--ink-soft)] ${className}`} data-testid="last-updated-badge">
            <i className="fa-regular fa-clock text-[var(--amber)]" />
            Mis à jour le{" "}
            <time dateTime={LAST_UPDATED} className="font-semibold text-[var(--navy)]">
                {LAST_UPDATED_FR}
            </time>
            <span className="hidden sm:inline">· Vérifié par nos techniciens</span>
        </p>
    );
}
